import {Component} from '@packages/systems/wfdl';
import {ExpressionElement} from '@packages/systems/wfdl-ast';
import {isComponentOnlyPageSlotDescendant} from './isComponentOnlyPageSlotDescendant';
import {getPageComponentFromComponentMap} from '@packages/utilities/core-elements';

export const isComponentInsidePageSlot = (
  componentMap: Component.ComponentMap,
  element: ExpressionElement
): boolean => {
  const pageComponent = getPageComponentFromComponentMap(componentMap);
  const pageRender = pageComponent && Component.getRender(pageComponent);

  return Boolean(
    element &&
    pageRender &&
    isComponentOnlyPageSlotDescendant(pageRender, element)
  );
};
